module.exports = __webpack_public_path__ + "img/icon1.92024c4b.png";